//Checkboxes in HTML transmit "on" when checked.
//But the clever guys writing the model binder at MS decided they won't parse "on" as C#'s true.
//So we need to normalize our forms ahead of time to handle this.
$(document).ready(function () {
  $('form').submit(function () {
    $(this).find("input[type=checkbox]:not([value])").each(function (index, element) {
      var el = $(element);
      el.attr("value", el.is(":checked") ? "true" : "false");
    });
  });
});